import React from "react";

import ScheduleListView from "./ScheduleListView";
import { strings, openNotificationWithIcon } from "../../../helpers";
import { deleteSchedule } from "../../../services";

export default class ScheduleListContainer extends React.Component {
  state = {
    showScheduleRemoveModal: false,
    scheduleId: "",
    isProcessing: false,
    doctorId: this.props.doctorsDetail.id
  };

  /**
   * @function toggleScheduleRemoveModal
   * @param scheduleId
   * @desc This function toggles remove modal, and sets the
   *  state variable scheduleId for deletion
   */
  toggleScheduleRemoveModal = scheduleId => {
    this.setState(prevState => ({
      showScheduleRemoveModal: !prevState.showScheduleRemoveModal,
      scheduleId
    }));
  };

  /**
   * @function handleDeletion
   * @desc This function handles schedule deletion
   */
  handleDeletion = () => {
    const { scheduleId, doctorId } = this.state;

    this.setState({ isProcessing: true });
    let result = null;
    result = deleteSchedule(doctorId, scheduleId);
    // if (this.props.scheduleType === "regular") {
    //   result = deleteSchedule(doctorId, scheduleId);
    // } else {
    //   result = deleteDiscountedSchedule(doctorId, scheduleId);
    // }
    result.then(response => {
      if (response.data.success) {
        // if it is timings for selected doctor in queue

        // show success message
        this.closeModal();
        openNotificationWithIcon(
          "success",
          `${"Remove"} ${"Schedule"}`,
          `${"Schedule"} ${"Removed"}`
        );
        this.props.getDetail();
      } else {
        // show error message
        openNotificationWithIcon(
          "error",
          `${"Remove"} ${"Schedule"}`,
          "Server Error"
        );
        this.closeModal();
      }
    });
  };

  /**
   * @function closeModal
   * @desc This function closes the remove schedule modal
   */
  closeModal = () => {
    this.setState({
      showScheduleRemoveModal: false,
      isProcessing: false,
      scheduleId: ""
    });
  };

  render() {
    const { doctorsDetail, handleEdit, scheduleType } = this.props;
    const { showScheduleRemoveModal, isProcessing } = this.state;
    return (
      <ScheduleListView
        doctorsDetail={doctorsDetail}
        toggleScheduleRemoveModal={this.toggleScheduleRemoveModal}
        showScheduleRemoveModal={showScheduleRemoveModal}
        handleEdit={handleEdit}
        handleDeletion={this.handleDeletion}
        isProcessing={isProcessing}
        closeModal={this.closeModal}
        scheduleType={scheduleType}
      />
    );
  }
}
